import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import LoadBox from '../../components/LazyBox';

//services
import ServicoAPI from '../../../services/api/Servico';

//css
import './servicos.css';


export default class Servicos extends React.Component {
	state = {
		servicos: [],

		loading:true,
	}

	refreshServicos = () => {
		ServicoAPI.lista_web()
			.then(res => {
			res.json().then(res => {
				if (res.msg) {
					return;
				}
				this.setState({ servicos: res, loading: false })
				return;
			})
		});
	}

	componentDidMount(){
		this.refreshServicos();
	}

    render() {
		const { servicos, loading } = this.state;
        return (
				<div className="app_content_page" >
					<Helmet>
						<title>Serviços</title>
						<meta name="description" content="Helmet application" />
					</Helmet>
					<div className="app_content_page__title_body" >
						<div className="title_body__content" >
							<Typography variant="h5" >Serviços</Typography>
						</div>
					</div>
					<div className="app_content_page__row" >
						<LoadBox loading={loading} height="50vh" >
							<Grid container spacing={16} >
								{servicos.map((s,k) => <Grid key={k} item xs={12} md={3} >
									<div className="service_group" >
										<div className="service_group__icon" >
											<img src={s.img} alt="" />
										</div>
										<div className="service_group__title" >
											<Typography variant="h5">{s.titulo}</Typography>
										</div>
										<div className="service_group__description" >
											<Typography variant="body1">{s.descricao}</Typography>
										</div>
									</div>
								</Grid>)}
							</Grid>
						</LoadBox>
					</div>
				</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/web/pages/servicos/index.js